import type { TourConfig } from "./types";
import { generatedScenes } from "./tour.scenes.generated";

/**
 * Tour 360° — 22 panorama khách chốt (anh360-khach-chon) + hotspot từ CSV sơ đồ.
 * Regenerate scenes: npm run generate-tour-config
 */
export const tourConfig: TourConfig = {
  defaultSceneId: "flycam-cao-toan-khu-37-5-ha",
  links: {
    mainWebsite: "https://hoalamshangrila.com.vn",
    hotline: "18009045",
    booking: {
      cih: "https://benhviencity.com.vn/dat-lich-kham",
      "gia-an": "https://benhviengiaan115.com/dat-lich-kham",
    },
  },
  groups: [
    { id: "overview", labelKey: "groups.overview", order: 1 },
    { id: "cih", labelKey: "groups.cih", order: 2 },
    { id: "gia-an", labelKey: "groups.gia-an", order: 3 },
  ],
  journeys: [
    {
      id: "investor",
      labelKey: "journeys.investor.label",
      descriptionKey: "journeys.investor.description",
      startSceneId: "flycam-cao-toan-khu-37-5-ha",
    },
    {
      id: "patient-cih",
      labelKey: "journeys.patient-cih.label",
      descriptionKey: "journeys.patient-cih.description",
      startSceneId: "sanh-chinh",
    },
    {
      id: "specialist-ga",
      labelKey: "journeys.specialist-ga.label",
      descriptionKey: "journeys.specialist-ga.description",
      startSceneId:
        "sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may",
    },
  ],
  scenes: generatedScenes,
};

export function getSceneById(id: string) {
  return tourConfig.scenes.find((s) => s.id === id);
}

export function getScenesByGroup(group: TourConfig["scenes"][0]["group"]) {
  return tourConfig.scenes
    .filter((s) => s.group === group)
    .sort((a, b) => a.order - b.order);
}

export function getOrderedSceneIds(): string[] {
  return [...tourConfig.groups]
    .sort((a, b) => a.order - b.order)
    .flatMap((group) => getScenesByGroup(group.id).map((s) => s.id));
}

export function getTotalHotspotCount(): number {
  return tourConfig.scenes.reduce((sum, s) => sum + s.hotspots.length, 0);
}
